/**
 * Table data view settings keys
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const TABLE_DATA_SETTINGS_KEYS = {
  TABLE_DATA_VIEW_VIRTUAL_MEASURES_SUMMARIZED_COLUMN_INDEX: 'table.columns.measuresSummarized.index',
  TABLE_DATA_VIEW_SHOW_GRAND_TOTAL_FOR_COLUMNS: 'table.showGrandTotalForColumns.enabled',
  TABLE_DATA_VIEW_SHOW_GRAND_TOTAL_FOR_ROWS: 'table.showGrandTotalForRows.enabled',
  TABLE_DATA_VIEW_SHOW_ROW_NUMBERS: 'table.rowNumbers.enabled',
  PIVOT_TABLE_MAX_MEASURES: 'table.pivot.maxMeasures',
  PIVOT_TABLE_MAX_COLUMN_DIMENSIONS: 'table.pivot.maxColumnDimensions',
  PIVOT_TABLE_MAX_ROW_DIMENSIONS: 'table.pivot.maxRowDimensions',
  TABLE_MAX_MEASURES: 'table.nonPivot.maxMeasures',
  TABLE_MAX_ROW_DIMENSIONS: 'table.nonPivot.maxRowDimensions',
  TABLE_DATA_VIEW_USE_DISTINCT: 'table.distinct.enabled',
  TABLE_FROZEN_COLUMNS: 'table.frozenColumns'
};

/**
 * Provide default values for backwards compatibility. (e.g. for DataViews that have been created
 * before bundle attribute limiting was implemented.)
 *
 * @see net/disy/cadenza/workbook/access/command/dataview/AddDataViewCommandExecutor.java
 * @see net/disy/cadenza/selection/api/config/PivotTableConfiguration.java
 */
export const TABLE_BUNDLE_ATTRIBUTE_LIMIT_DEFAULTS = {
  PIVOT_TABLE_MAX_MEASURES: 5,
  PIVOT_TABLE_MAX_COLUMN_DIMENSIONS: 4,
  PIVOT_TABLE_MAX_ROW_DIMENSIONS: 4,
  TABLE_MAX_ROW_DIMENSIONS: 20
};
